import { LockOpenRemoveOutlineIcon } from './LockOpenRemoveOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 73C80D40-9B24-42A8-A22A-94DDE61DDCFC
 * name lock-open-remove-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-remove-outline.svg
 * tags
 * - Lock 
 */
export const UnlockedRemoveOutlineIcon = LockOpenRemoveOutlineIcon;
export default UnlockedRemoveOutlineIcon